import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button
} from '@mui/material';
import { LoadingButton } from '@mui/lab';

export function EditDialog({
  open,
  pairUpCode,
  remark,
  setPairUpCode,
  setRemark,
  saving,
  onClose,
  onSubmit
}) {
  return (
    <Dialog open={open} onClose={!saving ? onClose : undefined}>
      <DialogTitle>編輯紀錄</DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          margin="dense"
          label="Pair Up Code"
          value={pairUpCode}
          onChange={(e) => setPairUpCode(e.target.value)}
        />

        <TextField
          fullWidth
          multiline
          minRows={2}
          margin="dense"
          label="備註"
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button disabled={saving} onClick={onClose}>取消</Button>
        <LoadingButton loading={saving} variant="contained" onClick={onSubmit}>
          儲存
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
